import { handleOpenChat } from "utils/analytics";

export default function WppFixed() {
  return (
    <div className="fixed right-5 bottom-5 z-50">
      <button onClick={handleOpenChat} type="submit" className="flex items-center bg-green-600 rounded-md py-2 px-4 abrir-chat" name="Abrir chat" id="abrir-chat">
        <img className="h-6" src="/wpp.png" alt="Beach Point Maragogi" title="Beach Point Maragogi" />
        <p className="text-white font-bold pl-2">ONLINE</p>
      </button>
    </div>
  )
}